// extracted by mini-css-extract-plugin
module.exports = {"rating":"styles_rating__32edX"};